import { ChevronDown } from '@aktiia/design-system';
import cx from 'classnames';
import { forwardRef, useMemo } from 'react';

import { BpStatusStyle } from '../../../../../constants';
import { getPatientBpState, getPatientBpStateText } from '../../../../../features/patients';
import { BpStatusBadge } from '../badge';
import { IBpStatusButtonProps } from './types';

const BpStatusButton = forwardRef<HTMLDivElement, IBpStatusButtonProps>(
  ({ status, onClick, showBackground = true, isUS = false }: IBpStatusButtonProps, ref) => {
    const filteredStatus = useMemo(() => getPatientBpState(status, isUS), [status, isUS]);
    const title = useMemo(() => getPatientBpStateText(status, isUS), [status, isUS]);

    const bgClassName = useMemo(() => {
      if (!showBackground) {
        return 'pr-0';
      }

      return `${BpStatusStyle[filteredStatus].bg} h-[24px]`;
    }, [filteredStatus]);

    return (
      <div
        ref={ref}
        className={cx('flex p-1 rounded-full items-center whitespace-nowrap', bgClassName)}
        onClick={onClick}
      >
        <BpStatusBadge status={filteredStatus} />

        <span
          className={cx(
            'typography-inline-highlight-3 text-text-primary capitalize status',
            !onClick && showBackground && 'mr-2',
          )}
        >
          {title}
        </span>

        {onClick && <ChevronDown className="scale-75" />}
      </div>
    );
  },
);
BpStatusButton.displayName = 'BpStatusButton';

export { BpStatusButton };
